import React from 'react';
import { eventLocations, getCities } from '../data/eventLocations';
import { formatCurrency } from '../utils/calculations';

function EventLocation({ settings, onChange }) {
  const cities = getCities(settings.country);

  const changeCountry = (event) => {
    const country = event.target.value;
    const firstCity = getCities(country)[0];
    onChange('country', country);
    onChange('city', firstCity.city);
    onChange('locationAdjustment', firstCity.adjustment);
  };

  const changeCity = (event) => {
    const city = event.target.value;
    const selected = cities.find((location) => location.city === city);
    onChange('city', city);
    onChange('locationAdjustment', selected?.adjustment || 0);
  };

  return (
    <div className="location-planner">
      <div className="location-heading">
        <div>
          <span className="section-kicker">Venue intelligence</span>
          <h3>Estimate by destination</h3>
        </div>
        <span className="location-impact">
          {settings.locationAdjustment >= 0 ? '+' : ''}
          {settings.locationAdjustment}% estimated change
        </span>
      </div>

      <div className="location-grid">
        <label className="field">
          <span className="field-label">Country</span>
          <select value={settings.country} onChange={changeCountry}>
            {Object.keys(eventLocations).map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </label>

        <label className="field">
          <span className="field-label">City</span>
          <select value={settings.city} onChange={changeCity}>
            {cities.map((location) => (
              <option key={location.city} value={location.city}>
                {location.city}
              </option>
            ))}
          </select>
        </label>

        <div className="location-note">
          <strong>
            {settings.locationAdjustment >= 0 ? '+' : ''}
            {formatCurrency(settings.locationAdjustment / 100, 2)}
          </strong>
          <span>
            Applied to eligible media, production, venue, and service estimates.
          </span>
        </div>
      </div>
    </div>
  );
}

export default EventLocation;